import React, { Fragment, useState } from 'react';
import { getBackgroundImg, getPublicImagePath, Modal, notifyError, notifySuccess, useAppDispatch } from '@nutastic/nutastic-react-app';
import PageHeader from '../PageHeader';
import Fade from 'react-reveal/Fade';
import { addReservation } from '../../actions/reservation-actions.mjs';
import { addSubscriber } from '@nutastic/nutastic-react-app/src/state/contact/subscription-actions.mjs';
import {validReservationEmails} from '../../utils/constants';

const ReservePage = () => {
    const dispatch = useAppDispatch();
    const componentClass = 'reserve-page';
    const rsvpList = validReservationEmails.filter(i => i.emails !== null);

    const [showModal, setShowModal] = useState(false);
    const [formStatus, setFormStatus] = useState(0);
    const [formValue, setFormValue] = useState({
        name: '',
        guest_name: '',
        guests: 0,
        email: '',
        message: ''
    });

    const onValueChange = (e, key) => {
        const updatedValue = e.target.value;
        setFormValue({
            ...formValue,
            [key]: updatedValue
        });
        if (formStatus !== 1) {
            setFormStatus(0);
        }
    };

    const getReservationData = () => {
        let matchedRecord = null;
        if (formValue.email) {
            const emailToValidate = formValue.email.toLowerCase().trim();
            matchedRecord = rsvpList.find(rsvp => {
                let hasValidEmail = false;
                if (Array.isArray(rsvp.emails)) {
                    hasValidEmail = (rsvp.emails || []).find(e => e.toLowerCase().trim() === emailToValidate);
                } else {
                    hasValidEmail = rsvp.emails.toLowerCase().trim() === emailToValidate
                }
                return hasValidEmail;
            });
        }
        return matchedRecord;
    };

    const onFormSubmit = (e, isSubmittingGuest) => {
        e.preventDefault();
        if (formValue.name && formValue.email) {
            const reservationData = getReservationData();
            if (reservationData) {
                if (reservationData.guests > 1 && !isSubmittingGuest) {
                    setShowModal(true);
                } else {
                    dispatch(addReservation(formValue));
                    dispatch(addSubscriber(formValue.email));
                    setFormStatus(1);
                    setShowModal(false);
                    setFormValue({
                        name: '',
                        guest_name: '',
                        guests: 0,
                        email: '',
                        message: ''
                    });
                    notifySuccess('Thank you for your RSVP. We can\'t wait to celebrate with you.');
                }
            } else {
                setFormStatus(-1);
                notifyError(null, null, 'We were unable to make a reservation for the email provided.');
            }
        } else {
            notifyError(null, null, 'Your full name and a valid email are required to make a reservation.');
        }
    };

    return <Fragment>
        <PageHeader
            image={getPublicImagePath('reserve-head.jpg')}
            content="Enter your information below to make your reservation for the big day!"
            iconClass="ion-md-paper-plane"
            subtitle="Save The Date"
            title="RSVP"
        />

        <section className={`${componentClass}__reserveSection flexSection flexSection--flipped`}>
            <Fade delay={250}>
                <div className="flexSection__image">
                    <div className="smallImages">
                        <div className="smallImg toLeft" style={getBackgroundImg(getPublicImagePath('calla1.jpg'))} />
                        <div className="smallImg toRight" style={getBackgroundImg(getPublicImagePath('calla2.jpg'))} />
                    </div>
                    <div className="bigImg" style={getBackgroundImg(getPublicImagePath('calla3.jpg'))} />
                </div>
            </Fade>
            <div className="flexSection__details form-section">
                <Fade delay={250}>
                    <h5>Reservations have been closed for the wedding. We look forward to seeing everyone!</h5>
                </Fade>
            </div>
        </section>

        <section className={`${componentClass}__infoSection flexSection`}>
            <Fade delay={250}>
                <div className="flexSection__image" style={getBackgroundImg(getPublicImagePath('callC.jpg'))}/>
            </Fade>
            <div className="flexSection__details">
                <Fade delay={250}><h2>WEDDING DETAILS</h2></Fade>
                <div className="icon-divider icon-divider--withBlack">
                    <i className="ion-ios-information-circle-outline" />
                </div>
                <p>Click here to view the details regarding attire, parking logistics, ceremony and reception requirements.</p>
                <a href="/about" className="btn btn-white">More Info</a>
            </div>
        </section>

        <Modal show={showModal} onClose={() => setShowModal(false)} title="RSVP Details">
            <p>
                You have a guest seat available with your RSVP. Please enter your guest information below, or leave blank if your guest is not
                 planning to attend the wedding.
            </p>
            <form onSubmit={(e) => onFormSubmit(e, true)}>
                <div className="form-group">
                    <input type="text" name="guest_name" value={formValue.guest_name} onChange={e => onValueChange(e, 'guest_name')} className="form-control" placeholder="Enter Guest Name"/>
                </div>
                <button type="submit" className="btn btn-primary">Continue</button>
            </form>
        </Modal>

    </Fragment>;
};

export default ReservePage;
